import {Component, Mixins} from 'vue-property-decorator';
import LoadingMixin from "@/mixins/LoadingMixin";
import ProductMixin from '@/mixins/ProductMixin';
import ShoppingCartMixin from '@/mixins/ShoppingCartMixin';
import {
    CustomerInfo,
    SelectedContractOption,
    Term,
    InstallationOption,
} from '@/products-and-services/ProductsAndServicesModels';
import SetupInstallation from "@/products-and-services/SetupInstallation.vue";
import ShoppingCartDetail from "@/products-and-services/ShoppingCartDetail.vue";
import {HTTP} from '@/services/HttpServices';
import {isNowAvailable} from '@/products-and-services/ProductsAndServicesService';
import VueRecaptcha from 'vue-recaptcha';
import { getTerms } from '@/products-and-services/ProductsAndServicesService';

interface CaptchaResult {
    captchaResponse: string;
}
@Component({
    components: {
        SetupInstallation,
        ShoppingCartDetail,
        VueRecaptcha
    }
})
export default class OrderReview extends Mixins(LoadingMixin, ProductMixin, ShoppingCartMixin) {
    private cartItems: any = {};
    private isCaptchaReady = false;
    private isCaptchaSuccess = false;
    private error: string = '';
    private nowAvailable = false;
    private captchaSiteKey = '';
    private captchaResponse = '';
    private terms: Term[] = [];

    get customerInfo(): CustomerInfo {
        return this.$store.getters.getCustomerInfo || {} as CustomerInfo;
    }

    get selectedContractId(): string {
        return this.$store.state.shoppingCartData.selectedContractId;
    }


    get cartNumber(): string|number {
        return this.$store.getters.getCartNumber();
    }

    get isResidential(): boolean {
        return window.location.pathname.includes('residential');
    }

    get contactName1(): string {
        if(this.isResidential) {
            return 'First Name'
        } else {
            return 'Business Name'
        }
    }

    get contactName2(): string {
        if(this.isResidential) {
            return 'Last Name'
        } else {
            return 'Contact Name'
        }
    }

    async created() {
        await this.execute(async () => {
            const { nowAvailable } = await isNowAvailable();
            this.nowAvailable = nowAvailable;
            this.terms = await getTerms(this.isResidential);
        }, 'Failed to retrieve availability data');
    }

    mounted() {
        this.cartItems = this.$store.getters.getShoppingCartSelection();
        this.registerCaptcha();
    }

    async registerCaptcha() {
        await this.execute(async () => {
            const { captchaSiteKey } = await HTTP.get(`/public/captcha`);
            this.captchaSiteKey = captchaSiteKey;
            this.isCaptchaReady = true;
        }, 'Failed to retrieve captcha data');
    }

    storeResponse(response: any) {
        this.captchaResponse = response;
        this.isCaptchaSuccess = true;
    }

    handleExpiration() {
        this.isCaptchaSuccess = false;
    }

    handleRecaptchaError() {
        this.error = 'Captcha failed. Please refresh this page and try again.';
        this.isCaptchaSuccess = false;
    }

    async submitOrder(installationOption: InstallationOption) {
        await this.execute(async () => {
            if (this.captchaResponse) {
                this.error = '';
                const captchaResult: CaptchaResult = { captchaResponse: this.captchaResponse };
                const validation = await HTTP.post(`/public/captcha/validate/${this.cartNumber}`, {
                    ...captchaResult
                });
                if (validation && validation.success) {
                    await this.$store.dispatch('updateOrderDetails', { mutation: 'submitted' });
                    this.$store.commit('submitOrder', installationOption);
                    await this.$router.push({ path: '/success' });
                } else {
                    this.error = 'Captcha failed. Please refresh this page and try again.';
                }
            }
        }, 'Failed to submit order.');
    }

}
